// temp fix for env variables
export const BASE_URL = process.env.REACT_APP_BASE_URL ?? 'https://portaireapi.herokuapp.com';
export const CHAT_URL = process.env.REACT_APP_SOCKET_URL ?? 'https://chatportaire.herokuapp.com';
